var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPhoto24Line(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7004 4.64941H7.30039C5.84039 4.64941 4.65039 5.83941 4.65039 7.29941V16.6994C4.65039 18.1594 5.84039 19.3494 7.30039 19.3494H16.7004C18.1604 19.3494 19.3504 18.1594 19.3504 16.6994V7.29941C19.3504 5.83941 18.1604 4.64941 16.7004 4.64941ZM17.6504 16.6994C17.6504 17.2244 17.2254 17.6494 16.7004 17.6494H7.30039C6.77539 17.6494 6.35039 17.2244 6.35039 16.6994V7.29941C6.35039 6.77441 6.77539 6.34941 7.30039 6.34941H16.7004C17.2254 6.34941 17.6504 6.77441 17.6504 7.29941V16.6994Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2554 11.5594C15.0004 11.0994 14.5154 10.8144 13.9854 10.8144C13.4554 10.8144 12.9754 11.0994 12.7154 11.5594L11.4354 13.8644L10.7204 12.7944C10.4504 12.3894 10.0004 12.1494 9.51539 12.1494C9.03039 12.1494 8.58039 12.3894 8.31039 12.7944L7.44539 14.0944C7.15039 14.5394 7.12039 15.1094 7.37539 15.5844C7.62539 16.0594 8.12039 16.3494 8.65539 16.3494H15.4554C15.9754 16.3494 16.4404 16.0844 16.7054 15.6344C16.9704 15.1894 16.9754 14.6494 16.7254 14.1944L15.2604 11.5594H15.2554Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhoto24Line);
export default __webpack_public_path__ + "static/media/icon_photo_24_line.2ba16e6e39bb180efa15fa5476f26b4d.svg";
export { ForwardRef as ReactComponent };